// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 8.00488V3H1V8.00488L23 8.00488Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 9.99536H1V21L23 21V9.99536ZM7.00015 12.0835L10.4144 15.4977L7.00015 18.9119L5.58594 17.4977L7.58594 15.4977L5.58594 13.4977L7.00015 12.0835ZM12.0002 16.4977H18.0002L18.0002 18.4977H12.0002V16.4977Z"}}]};

const TerminalRectangle1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'terminal-rectangle-1-filled',
    ref,
    icon: element,
  },
));

TerminalRectangle1FilledIcon.displayName = 'TerminalRectangle1FilledIcon';

export default TerminalRectangle1FilledIcon;
